import { redirect } from "@sveltejs/kit";
const load = async ({ locals, request }) => {
  let url = request.url.replace("://", "");
  url = url.substring(url.indexOf("/"));
  console.log("ADMIN LAYOUT SERVER", { user: locals.user, url });
  if (!locals.user && url !== "/admin/login") {
    throw redirect(302, "/admin/login");
  }
  return {
    user: locals.user
  };
};
export {
  load
};
//# sourceMappingURL=_layout.server.ts.js.map
